import React from "react";
import Slider from './Slider'

const marks = {
    0: {
        label: "",
    },
    10: {
        label: "L"
    },
    55: {
        label: "M"
    },
    100: {
        label: "H"
    }
}

const SliderQuestion = ({ question, questionNumber, changeSlider }) => {
    // console.log(question.answers)
    return (
        <div className="risk__subquestion">
            <div className="like__impact__questions">
                <div className="risk__number">
                    <p className="text">{questionNumber}</p>
                </div>
                <div className="risk__question like__impact__question">
                    <p>{question.question}</p>
                </div>
            </div>
            <div className="like__impact__text">
                <p className="likelihood__text">Likelihood</p>
                <p className="likelihood__impact">Impact</p>

            </div>
            {
                question.answers.map((answer, key) => {
                    // console.log(answer.selectedAnswer)
                    return (
                        <div key={key} className="like__impact">
                            <div className="like__impact__option">
                                <p>{answer.question}</p>
                            </div>
                            <div className="likelihood slider">
                                <Slider
                                    step={null}
                                    marks={marks}
                                    value={
                                        answer.selectedAnswer === null ? 0 :
                                            answer.selectedAnswer.likelihood === "Low" ? 10 :
                                                answer.selectedAnswer.likelihood === "Medium" ? 55 :
                                                    answer.selectedAnswer.likelihood === "High" ? 100 : 0
                                    }
                                    onChange={value => {
                                        changeSlider(value, questionNumber, answer.question, 'likelihood')
                                    }} />
                            </div>
                            <div className="impact slider">
                                <Slider
                                    step={null}
                                    marks={marks}
                                    value={
                                        answer.selectedAnswer === null ? 0 :
                                            answer.selectedAnswer.impact === "Low" ? 10 :
                                                answer.selectedAnswer.impact === "Medium" ? 55 :
                                                    answer.selectedAnswer.impact === "High" ? 100 : 0
                                    }
                                    onChange={value => {
                                        changeSlider(value, questionNumber, answer.question, 'impact')
                                    }}
                                />
                            </div>
                        </div>
                    )
                })}
        </div>
    );
};

export default SliderQuestion;



// WEBPACK FOOTER //
// ./src/components/sra/components/SliderQuestion.js